import React from 'react';
import PropTypes from 'prop-types';
import about from './images/About.svg';
import house from './images/House.svg';
import modem from '../../assets/hg659-small.png';
import mouse from './images/User.svg';
import meter from './images/Question.svg';
import smartModem from '../../assets/smartmodem-small.png';
import './Support.scss';

const imageMap = {
  'about-skinny-unlimited-broadband': about,
  'getting-skinny-unlimited-broadband': house,
  'the-skinny-unlimited-HG659-modem': modem,
  'the-skinny-smart-modem': smartModem,
  'your-account': mouse,
  support: meter
};

const SupportImage = props =>
  <img className="support-image" src={imageMap[props.id]} role="presentation" />;

SupportImage.propTypes = { id: PropTypes.string };

export default SupportImage;



/** WEBPACK FOOTER **
 ** ./src/components/Support/SupportImage.js
 **/